import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface PageHeaderProps {
    title: string
    description?: ReactNode
    eyebrow?: ReactNode
    actions?: ReactNode
    className?: string
}

export const PageHeader: FC<PageHeaderProps> = ({ title, description, eyebrow, actions, className }): ReactNode => {
    return (
        <div className={cn('flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between', className)}>
            <div className='min-w-0 space-y-1.5'>
                {eyebrow && (
                    <p className='text-xs font-medium text-muted-foreground'>
                        {eyebrow}
                    </p>
                )}

                <h1 className='font-heading text-2xl font-semibold tracking-tight text-balance text-foreground sm:text-[1.75rem]'>
                    {title}
                </h1>

                {description && (
                    <p className='max-w-2xl text-sm leading-relaxed text-pretty text-muted-foreground'>
                        {description}
                    </p>
                )}
            </div>

            {actions && (
                <div className='flex flex-wrap items-center gap-2'>
                    {actions}
                </div>
            )}
        </div>
    )
}
